import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { PatientBodyHeightEditDrawer } from '@app/icare/entities/patient/edits/PatientBodyHeightEditDrawer'
import { PatientStammdatenEditDrawer } from '@app/icare/entities/patient/edits/PatientStammdatenEditDrawer'
import { patientQueryOptions } from '@app/icare/entities/patient/queries/patientQueryOptions'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { entityParams } from '@pkg/db/utils'
import { EditSectionButton } from '@pkg/ui/button'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/anamnese/koerpergroesse')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) => queryClient.ensureQueryData(patientQueryOptions(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id: patientId } = Route.useParams()
  const { data } = useSuspenseQuery(patientQueryOptions(patientId))
  const height = data?.personal?.height

  return (
    <ProCard
      title={<Trans>Körpergröße</Trans>}
      extra={
        <EditSectionButton onClick={() => void PatientBodyHeightEditDrawer.show({ patientId, section: 'edit' })} />
      }
    >
      <ProDescriptions column={1}>
        <ProDescriptions.Item label={t`Körpergröße`}>{height != null ? `${height} cm` : '-'}</ProDescriptions.Item>
      </ProDescriptions>
    </ProCard>
  )
}
